import React from 'react';
import classNames from 'classnames';
import FieldWithAttributeDTO from '../../../components/fields/Abstract/FieldWithAttributeDTO';
import { Icons } from '../../../components/base/BootstrapComponents';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import CustomButton from '../../../components/base/Button/CustomButton';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import { zonesIcon } from './moks';

export default function ZonesAddOptionPopUp(props) {
  const { onHide, item } = props;
  return (
    <Dialog
      className={classNames('zone-card-add-option-popup')}
      onClose={() => { onHide(); }}
      size="m"
      open
    >
      <DialogTitle
        className="hff-title"
        title={(
          <>
            <div className="hff-title-text f2">Укажите параметры машиноместа для зоны {item.name}</div>
            <div className="hff-close-wrapper">
              <Icons width={14} height={14} customIcon icon="clear" className="hff-close" onClick={() => { onHide(); }} />
            </div>
          </>
        )}
      />
      <DialogContent className="hff-content">
        <FieldWithAttributeDTO
          type="text"
          component={TextInputWithLabel}
          placeholder="Укажите название"
          dtoObject={{
            name: 'zones.mechanical',
            type: String,
            validators: [],
            labelKey: 'zones.mechanical',
          }}
          inputProps={{
            // value: item.total,
          }}
        />
        <FieldWithAttributeDTO
          type="text"
          component={TextInputWithLabel}
          placeholder="Укажите количество мест"
          dtoObject={{
            name: 'zones.totalSeat',
            type: String,
            validators: [],
            labelKey: 'zones.totalSeat',
          }}
          inputProps={{
            // value: item.total,
          }}
        />
        <FieldWithAttributeDTO
          type="text"
          placeholder="Выберите зону"
          renderOption={item => (
            <Icons width={24} height={24} customIcon icon={item.icon} />
          )}
          dtoObject={{
            name: 'zones.selectIcon',
            type: String,
            validators: [],
            labelKey: 'zones.selectIcon',
          }}
          inputProps={{
            // ...register('zones', { maxLength: 30 }),
            // onChange: e => {
            //   setValue('zones', e.target.value);
            // },
            // value: Number(getValues('zones')),
          }}
          component={CustomSelectInput}
          options={zonesIcon}
          className="filter-margin"
          withLabel
        />
      </DialogContent>
      <DialogFooter className="hff-footer">
        <CustomButton text="Сохранить" onClick={() => {}} />
        <CustomButton isCancel text="Закрыть" onClick={() => { onHide(); }} />
      </DialogFooter>
    </Dialog>
  );
}
